import "react";
import "./auth-service-tools177.js";
import { useMantineClassNamesPrefix, useMantineWithStaticClasses, useMantineIsHeadless } from "./auth-service-tools199.js";
import { useMantineTheme } from "./auth-service-tools196.js";
import { getClassName } from "./auth-service-tools200.js";
import { getStyle } from "./auth-service-tools201.js";
import { useStylesTransform } from "./auth-service-tools202.js";

function useStyles(_ref) {
  let {
    name,
    classes,
    props,
    stylesCtx,
    className,
    style,
    rootSelector = "root",
    unstyled,
    classNames,
    styles,
    vars,
    varsResolver
  } = _ref;
  const theme = useMantineTheme();
  const classNamesPrefix = useMantineClassNamesPrefix();
  const withStaticClasses = useMantineWithStaticClasses();
  const headless = useMantineIsHeadless();
  const themeName = (Array.isArray(name) ? name : [name]).filter(n => n);
  const {
    withStylesTransform,
    getTransformedStyles
  } = useStylesTransform({
    props,
    stylesCtx,
    themeName
  });
  return (selector, options) => ({
    className: getClassName({
      theme,
      options,
      themeName,
      selector,
      classNamesPrefix,
      classNames,
      classes,
      unstyled,
      className,
      rootSelector,
      props,
      stylesCtx,
      withStaticClasses,
      headless,
      transformedStyles: getTransformedStyles([options == null ? void 0 : options.styles, styles])
    }),
    style: getStyle({
      theme,
      themeName,
      selector,
      options,
      props,
      stylesCtx,
      rootSelector,
      styles,
      style,
      vars,
      varsResolver,
      headless,
      withStylesTransform
    })
  });
}

export { useStyles };